export const CHECKBOX = 'checkbox';
export const RADIO = 'radio';
export const VARIANT_L = 'L';

export type InputCardType = typeof CHECKBOX | typeof RADIO;

export interface InputCardProps {
  isDisabled: boolean;
  isChecked: boolean;
  handleClick: () => void;
  type: InputCardType;
  variant?: typeof VARIANT_L;

  children?: React.ReactNode;
}
